import countdownBasicScript from "../Countdown/countdown-basic-script";
import { toRGBA } from "./utils";

export const getFormConf = (tree) => {
  const fieldsConfig = {}; // Form validation rule settings for jQuery validation
  const libsConfig = {}; // JS library settings
  const { formPlaceholderColor, formErrorColor } = tree.root.data;
  const styleConfig = `
    <style>
      ::placeholder {
        color: ${toRGBA(formPlaceholderColor)};
        opacity: 1; /* Firefox */
      }
      
      ::-ms-input-placeholder { /* Edge 12 -18 */
        color: ${toRGBA(formPlaceholderColor)};
      }
      .rip-form-input.error, .rip-form-error .error {
        color: 
      }
      .rip-form-input.error {
        border-color: ${toRGBA(formErrorColor)}!important;
      }
      .rip-form-error .error {
        color: ${toRGBA(formErrorColor)}!important;
      }
    </style>
    `
  let hasFormComponents = false;
  tree.traverseDF((item) => {
    if (item.type === "countdown") {
      libsConfig.countdownLib = true;
    }

    if (item.type.startsWith("form-") && item.type !== "form-submit-button") {
      hasFormComponents = true;
      if (item.type === "form-phone") {
        libsConfig.ripPhoneLib = true;
      }
      if (item.type === "form-terms") {
        libsConfig.ripTermsLib = true;
      }
      if (item.type === "form-rating") {
        libsConfig.ripStarsRating = true;
      }

      fieldsConfig[item.id] = {
        required: item.data.required,
        ripFormType: item.type,
      };
      switch (item.type) {
        case "form-text":
        case "form-textarea":
          if (item.data.maxlength) {
            fieldsConfig[item.id].maxlength = Number(item.data.maxlength);
          }
          if (item.data.minlength) {
            fieldsConfig[item.id].minlength = Number(item.data.minlength);
          }
          break;
        case "form-email":
          fieldsConfig[item.id].email = true;
          if (item.data.maxlength) {
            fieldsConfig[item.id].maxlength = Number(item.data.maxlength);
          }
          if (item.data.minlength) {
            fieldsConfig[item.id].minlength = Number(item.data.minlength);
          }
          break;
        case "form-number":
          if (item.data.min) {
            fieldsConfig[item.id].min = Number(item.data.min);
          }
          if (item.data.max) {
            fieldsConfig[item.id].max = Number(item.data.max);
          }
          break;
        case "form-url":
          fieldsConfig[item.id].url = true;
          break;
        case "form-phone":
          fieldsConfig[item.id].ripPhoneNo = true;
          break;
        case "form-radio-grid":
          fieldsConfig[item.id].rowsLength = item.data.rows.length;
        default:
          break;
      }
    }
  });
  return {
    fieldsConfig,
    libsConfig,
    hasFormComponents,
    styleConfig
  };
};


export default ({ fieldsConfig, libsConfig, hasFormComponents, styleConfig }) => {

  if (!hasFormComponents) {
    if (libsConfig.countdownLib) {
      return `
         <script src="https://riplus-hk.rimanggis.com/file/rip-mm-vendors/jquery-3.3.1.min.js"></script>
         ${countdownBasicScript}
      `;
    }
    return "";
  }

  function parseFieldsConfigToRules(obj) {
    const result = {};
    for (const key in obj) {
      if (obj[key].ripFormType === "form-radio-grid") {
        const { rowsLength, ...newObj } = obj[key];
        for (let i = 0; i < rowsLength; i++) {
          result[`${key}-${i}`] = newObj;
        }
      } else {
        result[key] = obj[key];
      }
    }
    return result;
  }

  var rules = parseFieldsConfigToRules(fieldsConfig);
  return `
    ${styleConfig}
    <script id="question-conf">
      var questionsConfig = ${JSON.stringify(fieldsConfig)};
    </script>
    <script>
    var pendingIntervalIds = [];
    function getData() {
      var data = {};
      if ($('input[name="_openid"]')){
        data._openid = $('input[name="_openid"]').val();
      }
      Object.keys(questionsConfig).forEach((id) => {
        var field = questionsConfig[id];
        if (field.ripFormType === "form-phone") {
          data[id] = document.getElementById(id).value;  // phone number
          var code = document.getElementById(id + "-code").value.replace("+", "");
          data[id + "-code"] = code;  // country code
        } else if (field.ripFormType === "form-multi-option") {
          var vals = $('input[name="' + id + '"]:checked').map((idx, item) => $(item).val()).get();
          data[id] = vals;
        } else if (field.ripFormType === "form-option") {
          var val = $('input[name="' + id + '"]:checked').val();
          data[id] = val;
        } else if (field.ripFormType === "form-radio-grid") {
          $('#'+ id +' table tr:not(:first)').each(function(index, obj) {
              var questionName = id + '-' + index;
              var val = $('input[name=' + questionName + ']:checked').val();
              data[questionName] = val || "";
          });

        } else if (field.ripFormType === "form-rating") {
          // need to check has star type or number type
          if ($('div#' + id + '.rip-star-rating').length > 0) {
            var val = $('div#' + id + '.rip-star-rating label[data-select="true"]').first().attr('data-value');
          } else {
            var val = $('input[name="' + id + '"]:checked').first().val();
          }
          data[id] = val;
        } else if (field.ripFormType === "form-terms") {
          var val = $('input[name="' + id + '"]:checked').val();
          if (val) {
            data[id] = "true";
          }
        } else {
          var val = $('[name="' + id + '"').val();
          data[id] = val;
        }
      });
      return data;
    }

    // validation rip form with jQuery validation
    $(window).ready(function() {
      jQuery.validator.addMethod("ripFormType", function() {
        return true;
      }, "Internal use.");
      ${libsConfig.ripPhoneLib
        ? `jQuery.validator.addMethod("ripPhoneNo", function(value, element) {
            var codeId = element.id + "-code";
            var code = document.getElementById(codeId).value;
            if (!value) return true;
            try {
              return libphonenumber.parsePhoneNumber('+' + code + value).isValid();
            } catch (error) {
              return false;
            }
          }, "Please enter a valid phone number.");

          Object.keys(questionsConfig).forEach((id) => {
            var field = questionsConfig[id];
            if (field.ripFormType === "form-phone") {
            document.getElementById(id + "-code").addEventListener("change", (event) => {
                $("#rip-mm-container").validate().element("[id='" + id + "']");
              });
            }
          });`
        : ""
      }
      var validator = $("#rip-mm-container").validate({
        debug: true,
        focusInvalid: true,
        ignore: [],
        submitHandler: function (form) {
          console.log(form);
        },
        rules: ${JSON.stringify(rules)},
        errorPlacement: function (error, element) {
          var placement = $(element).closest(".rip-field-group").find('.rip-form-error');
          if (placement) {
            $(placement).html(error)
          } else {
            error.insertAfter(element);
          }
        }
      });
      $(".rip-mm-submit-btn.submit").on("click", function() {
        var isPreviewMode = sessionStorage.getItem('isPreviewMode');
        if (isPreviewMode) {
          if (validator.form()) {
            var action = $(".rip-mm-submit-btn.submit").data('action');
            var redirectUrl = $(".rip-mm-submit-btn.submit").data('redirect');
            if (action === "redirectUrl" || action === "landing") {
              if (redirectUrl) {
                window.open(redirectUrl, '_blank');
              } else {
                alert("ERROR: Submited form redirect url or Landing page config error.");
              }
            } else if (action === "contentBlock") {
                $(".rip-field-group").remove();
                $(".rip-mm-form-thankyou").css({display: "block"});
            } else {
                alert("Submited");
            }
          }
          return;
        }
        
        if (!window.RIP_MM_CONF || !window.RIP_MM_CONF.submit_url) {
          return alert("ERROR: Form submit url is undefined!");
        }
        if (validator.form()) {
          var data = getData();

          // handle preview logic
          var pathname = window.location.pathname;
          var splitted = pathname.split("/");
          var isPreview = splitted[2] === "preview";
          data.is_preview = isPreview;

          var action = $(this).data("action");
          var redirectUrl = $(this).data("redirect");
          var contentBlock = $(this).data("content");
          function submitedCb (data) {
            if (data.status === 200) {
              alert("Success");
            }
          }
          $.ajax({
              complete: window.RIP_MM_CONF.submitedCb || submitedCb,
              contentType: "application/json",
              dataType: "json",
              type: "POST",
              data: JSON.stringify(data),
              url: window.RIP_MM_CONF.submit_url
          });
        }
      });

      $(".rip-mm-submit-btn.close").on("click", function () {
        var signupWrapper = $(this).closest(".sign-up-wrapper");
        if (signupWrapper.length) {
          signupWrapper.addClass("animate__animated animate__fadeOut");
          setTimeout(function() {
            signupWrapper.css({"display": "none"});
          }, 1000);
        } else {
          window.close();
        }
      });

      $(".rip-mm-submit-btn.reset").on("click", function() {
        $(this).closest("form").trigger("reset");
        // reset for star radio
        Object.keys(questionsConfig).forEach((id) => {
          var field = questionsConfig[id];
          if (field.ripFormType === "form-rating") {
            if ($('div#' + id + '.rip-star-rating').length > 0) {
              $("div#" + id + '.rip-star-rating').find("label").val('').attr("data-select", "false");
            }
          }
        });
      });
    });
    </script>
    `
}